import { readableColor } from "polished";
import { DefaultTheme } from "styled-components";

export const getReadableColor = (
  theme: DefaultTheme,
  locale?: "header" | "footer"
) => {
  let color = "#ffffff";
  const { colors } = theme;
  if (colors.header && locale === "header") {
    color = readableColor(colors.header);
  } else if (colors.footer && locale === "footer") {
    color = readableColor(colors.footer);
  } else if (colors.background) {
    color = readableColor(colors.background);
  }

  return color;
};
